import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class PushNotificationsTokenApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/mobile-push-user-tokens`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async updateUserPushNotificationToken(
		oldToken: string,
		newToken: string,
		timestamp: string
	) {
		const context = getApiRequestContext();
		return httpClient.put(
			`${this.baseUrl}/token`,
			JSON.stringify({
				oldToken,
				newToken,
				timestamp,
			}),
			this.getRequestHeaders(context),
			{ responseType: "raw" }
		);
	}

	static async setUserPushNotificationToken(pushToken: string) {
		const context = getApiRequestContext();

		return httpClient.post(
			`${this.baseUrl}/user-token-post`,
			JSON.stringify({
				token: pushToken,
				userId: context?.userId,
				agencyId: context?.agencyId,
			}),
			this.getRequestHeaders(context)
		);
	}
}
